// extracted by mini-css-extract-plugin
module.exports = {"tabs":"AdvancedFilterTabs_tabs__ZAZLj","panelWrapper":"AdvancedFilterTabs_panelWrapper__7vGvq"};